import template from './questions.json'
import path from 'object-path'
import * as immu from 'object-path-immutable'

// -----------------------------
// Construct nexted objet graph
// -----------------------------
export function getGraph( faqs ) {

  // Gather all question paths here
  var paths = {}
  // Recursive drill down from root
  function down( chain, value = null ) {
    // Set predecessor chain key
    paths = immu.set( paths, `${chain}`, value )
    // Check children for group
    for ( const key of getKeys( faqs, chain.split( "." ).pop() ) ) {
      down( `${chain}.${key}` )
    }
  }
  // Find all starting points
  const roots = Object.keys( faqs ).filter( isRoot )
  // Init recursive function for each root
  for ( const root of roots ) down( root )
  // {
  //   "symptome": {
  //     "vegetativ": {
  //       "hyperhidrosis": null
  //     }
  //   }
  // }
  return paths
}


// ---------------------------------------------------
// Find group we should ask next from top down
// Try to stay in group path and force group
// ---------------------------------------------------
export function getNext( faqs, group, force = false ) {
  const graph = getGraph( faqs )
  // Put first group with missing value here
  var next = null
  // Recursive function to look for missing value top down
  function todo( group ) {
    // Some key in this group has no value
    for ( const key of Object.keys( faqs[ group ] ) ) {
      // Group has missing value for this key
      if ( !faqs[ group ][ key ] ) {
        next = group;
        break;
      }
      // Descend down to next group
      else if ( faqs[ key ] ) todo( key )
    }
  }
  // Wishing this group
  if ( group ) {
    // Check upstream
    todo( getRoot( group ) )
    // upstream is filled out
    if ( !next && force ) return group
    // if found next
    if ( next ) return next
  }
  // Try all paths
  for ( const root of Object.keys( graph ) ) todo( root )
  //
  return next
}

// --------------------------------------------
// Process lega aka group.key from view-advice
// --------------------------------------------
export function setKey( faqs, lega ) {
  if ( !lega ) return faqs
  // Support legacy keys with dot
  var key = lega.includes( "." ) ? lega.split( "." )[ 1 ] : lega
  var group = getGroup( key )
  var valu = null
  // Ensure value
  valu = path.get( faqs, `${group}.${key}`, null )
  faqs = immu.set( faqs, `${group}.${key}`, valu )
  // Check for necessary predecessor in template
  while ( getGroup( group ) ) {
    // Goto predecessor
    key = group
    group = getGroup( key )
    // Ensure value
    valu = path.get( faqs, `${group}.${key}`, null )
    faqs = immu.set( faqs, `${group}.${key}`, valu )
  }
  return faqs
}

// ------------------------------------------------
// Iterate graph to change downfall values for key
// with logic for yes, no, unknown
// ------------------------------------------------
export function setValue( faqs, key, value, propagate = true ) {
  // Ensure key
  faqs = setKey( faqs, key )
  // Get Group
  const group = getGroup( key )
  // Set value
  faqs = immu.set( faqs, `${group}.${key}`, value )
  // Recursive function to propate down
  // Special Case: Parents has differnt values e.g. gentest no => cytochrome unknown
  function down( grou, valu1, valu2 ) {
    for ( const ke of getKeys( faqs, grou ) ) {
      // Catch if valu is not available
      if ( template[ group ][ key ].includes( valu1 ) ) {
        faqs = immu.set( faqs, `${grou}.${ke}`, valu1 )
      } else if ( template[ group ][ key ].includes( valu2 ) ) {
        faqs = immu.set( faqs, `${grou}.${ke}`, valu2 )
      } else if ( valu1 == null ) {
        faqs = immu.set( faqs, `${grou}.${ke}`, null )
      }
      down( ke, valu1 )
    }
  }
  // Propagate no down
  if ( propagate && value == "no" ) down( key, "no", "unknown" )
  // Propagate unknown down
  if ( propagate && value == "unknown" ) down( key, "unknown" )
  // Propagate null down if yes
  if ( propagate && value == "yes" ) down( key, null )
  // Propaget null down if null
  if ( propagate && value == null ) down( key, null )
  //
  return faqs
}

// --------------------------------------
// Find group for key in template
// --------------------------------------
export function getGroup( key ) {
  return Object.keys( template ).filter( group => {
    return !!path.get( template, `${group}.${key}` )
  } ).pop() || null
}

// --------------------------------------
// Find root for group in template
// --------------------------------------
export function getRoot( group ) {
  while ( !isRoot( group ) ) {
    if ( getGroup( group ) ) {
      group = getGroup( group )
    } else {
      console.log( "> Flow Error: Group null in getRoot" )
      break;
    }
  }
  return group
}

// -----------------------
// List all keys in group
// -----------------------
export function getKeys( faqs, group ) {
  // Catch leaf group
  if ( !faqs || !faqs[ group ] ) return []
  // Array with keys
  return Object.keys( faqs[ group ] )
}

// ---------------------------------
// List all values of keys in group
// ---------------------------------
export function getValues( faqs, group ) {
  return getKeys( faqs, group ).map( key => faqs[ group ][ key ] )
}

// ------------------------------------------------
// Boolean if all keys are [ no, unknown or null ]
// if true don't show summary
// ------------------------------------------------
export function allKeys( faqs, group, condis ) {
  return getValues( faqs, group ).every( value => {
    return condis.includes( value )
  } )
}

// -----------------------------------
// Is group never key in other groups
// -----------------------------------
export function isRoot( groupNotKey ) {
  return Object.keys( template ).every( group => {
    return typeof template[ group ][ groupNotKey ] == "undefined"
  } )
}

// ---------------------------------------
// Does group has no key which is a group
// ---------------------------------------
export function isLeaf( group ) {
  return Object.keys( template[ group ] ).every( keyIsGroup => {
    return !template[ keyIsGroup ]
  } )
}

// -----------------------------------
// Group keys are completely answered
// -----------------------------------
export function isDone( faqs, group ) {
  return Object.keys( faqs[ group ] ).every( key => {
    return !!faqs[ group ][ key ]
  } )
}

// --------------------------------------------
// If not top-level think about correcting the
// parent in certain cases
// --------------------------------------------
export function correctParents( faqs, group ) {
  while ( isRoot( group ) == false ) {
    // Get all values of keys
    const values = getValues( faqs, group )
    // Check values length just in case and only nos or unknowns
    if ( values.length && values.every( val => val == "no" ) ) {
      faqs = setValue( faqs, group, "no", false )
    }
    if ( values.length && values.every( val => val == "unknown" ) ) {
      faqs = setValue( faqs, group, "unknown", false )
    }
    if ( values.length && group == "cytochrome" && values.some( val => !!val ) ) {
      faqs = setValue( faqs, group, "yes", false )
    }
    group = getGroup( group )
  }
  return faqs
}

// --------------------------------------
// Provide element ready state for group
// --------------------------------------
export function getState( faqs, group ) {

  const state = {
    // summary: false,
    // lang: "de"
    "group": group,
    "keys": {}
  }
  // Get available keys from group in store
  const store = path.get( faqs, group, {} )
  // Find all default values
  const blue = path.get( template, group, {} )
  // Iterate store keys
  for ( const key of Object.keys( store ) ) {
    state.keys[ key ] = {
      options: blue[ key ],
      value: store[ key ]
    }
  }
  // view-findings will add summary and lang
  return state

}